module.exports = __webpack_public_path__ + "static/media/gk-testimonials-4.ee5f8174.png";